module.exports = __webpack_public_path__ + "img/partner_3.8c36b45f.png";